import { selectOnboarding } from '../../selectors'

const DEFAULT_FORM_FIELDS = {
  emailInput: '',
}

function selectBase(state) {
  return selectOnboarding(state).signup || {}
}

export function selectFormFields() {
  return DEFAULT_FORM_FIELDS
}

export function selectIsCreatingAccount(state) {
  return selectBase(state).isCreatingAccount || false
}
